import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const SideNav = ({ scrollContainerRef, onLoginClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);

  const toggleNav = () => setIsOpen(!isOpen);

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const id = typeof targetId === "string" ? targetId.toLowerCase().replace(/\s+/g, "-") : targetId;
    const targetElement = document.getElementById(id);
    if (targetElement && scrollContainerRef?.current) {
      const containerRect = scrollContainerRef.current.getBoundingClientRect();
      const targetRect = targetElement.getBoundingClientRect();
      scrollContainerRef.current.scrollTo({
        left: targetRect.left - containerRect.left + scrollContainerRef.current.scrollLeft,
        behavior: "smooth",
      });
    }
    toggleNav();
  };

  return (
    <>
      <button
        onClick={toggleNav}
        className="fixed top-4 left-4 z-50 p-2 sm:p-1 min-w-[48px] min-h-[48px] flex items-center justify-center bg-transparent transition-transform duration-300 ease-in-out hover:scale-110 active:scale-95 touch-manipulation"
        aria-label="Open menu"
      >
        <img src="./logo.png" alt="Driscoll Co Logo" className="w-16 h-16 sm:w-24 sm:h-24 object-contain" />
      </button>
      <div
        className={`fixed inset-0 bg-black transition-opacity duration-300 ease-in-out ${isOpen ? "opacity-50 z-40" : "opacity-0 pointer-events-none"}`}
        onClick={toggleNav}
      />
      <nav
        className={`fixed top-0 left-0 bottom-0 w-[min(280px,85vw)] max-w-[280px] bg-white z-50 transform transition-all duration-300 ease-in-out pt-[env(safe-area-inset-top)] ${isOpen ? "translate-x-0 scale-100 opacity-100" : "-translate-x-full scale-95 opacity-0"}`}
      >
        <div className="p-4 sm:p-6 overflow-y-auto h-full">
          <img src="./logo.png" alt="Driscoll Co Logo" className="w-24 h-24 sm:w-32 sm:h-32 object-contain mb-4 sm:mb-6" />
          <ul className="space-y-1 mb-6">
            {["Home", "Commercial", "Investment", "Residential", "Listing", "About", "Agents", "Links", "Contact"].map((s) => (
              <li key={s}>
                <a href={`#${s.toLowerCase().replace(/\s+/g, "-")}`} className="text-gray-700 hover:font-bold inline-block py-3 px-2 min-h-[44px] flex items-center touch-manipulation -mx-2 rounded-lg hover:bg-gray-50 active:bg-gray-100" onClick={(e) => handleNavClick(e, s)}>{s}</a>
              </li>
            ))}
          </ul>
          <div className="border-t pt-4 sm:pt-6 space-y-3">
            {user ? (
              <>
                <p className="text-sm text-gray-600">Welcome, <span className="font-semibold">{user.firstName || user.email}</span></p>
                <a href="/dashboard" className="block w-full bg-blue-600 text-white text-center py-3 rounded-lg hover:bg-blue-700 min-h-[44px] flex items-center justify-center touch-manipulation" onClick={(e) => { e.preventDefault(); window.location.href = '/dashboard'; }}>Dashboard</a>
                <button onClick={() => { logout(); toggleNav(); window.location.href = '/'; }} className="w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 min-h-[44px] touch-manipulation">Logout</button>
              </>
            ) : (
              <button onClick={() => { onLoginClick(); toggleNav(); }} className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium min-h-[44px] touch-manipulation">Login</button>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default SideNav;
